import React from "react";

const categories = [
  {
    emoji: "💻",
    title: "Digital Business",
    desc: "AI services, digital marketing, websites, social media, virtual assistance, content creation."
  },
  {
    emoji: "🛍️",
    title: "Online Store",
    desc: "Fashion, jewellery, gifting, reselling, handmade products and curated collections."
  },
  {
    emoji: "🍰",
    title: "Food & Home",
    desc: "Home bakery, healthy foods, pickles, chocolates, snacks and cloud kitchens."
  },
  {
    emoji: "🎨",
    title: "Creative Studio",
    desc: "Photography, graphic design, branding, illustrations, crafts and personalised gifts."
  },
  {
    emoji: "💄",
    title: "Beauty & Wellness",
    desc: "Salon, skincare, fitness, yoga, makeup, wellness coaching and self-care."
  },
  {
    emoji: "🎓",
    title: "Education",
    desc: "Tutoring, coaching, online classes, workshops and skill development."
  },
  {
    emoji: "🌾",
    title: "Agri & Rural",
    desc: "Millets, spices, honey, handicrafts, SHGs and farm value-added products."
  },
  {
    emoji: "🏪",
    title: "Digital Boutique",
    desc: "Become a PurpleDoor Digital Master Distributor or Coordinator and empower your community."
  }
];

const FoundHerOpportunities = () => {
  return (
    <section className="py-4 px-4 bg-gradient-to-b from-[#2a1031] via-[#33122f] to-[#220b20]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-5">
          <div className="uppercase tracking-[0.25em] text-pink-300 font-semibold mb-4">
            🚀 BUILD YOUR FUTURE
          </div>
          <h2 className="text-xl lg:text-2xl font-black text-white mb-4">
            One Platform.
            <br />
            Hundreds of Possibilities.
          </h2>
          <p className="max-w-4xl mx-auto text-sm lg:text-lg text-rose-200 leading-relaxed">
            Whether you're a student, homemaker, creator, freelancer,
            artisan or aspiring entrepreneur, FoundHer helps you
            discover purpose, learn practical skills, launch your
            first business and grow with the support of mentors,
            customers and your local community.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
          {categories.map((item, index) => (
            <div
              key={index}
              className="rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md p-5 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="text-xl lg:text-2xl mb-3">
                {item.emoji}
              </div>
              <h3 className="text-sm lg:text-lg font-bold text-white mb-2">
                {item.title}
              </h3>
              <p className="text-xs lg:text-sm text-rose-200 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-4 rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md p-6">
          <div className="text-center">
            <h3 className="text-lg lg:text-xl font-bold text-white mb-3">
              💜 More Than Entrepreneurship
            </h3>
            <p className="text-sm lg:text-base text-rose-200 leading-relaxed max-w-4xl mx-auto">
              FoundHer combines the purpose discovery of <strong>Think5Whys</strong> with
              the digital commerce ecosystem of <strong>PurpleDoor</strong>.
              Learn through the Academy, build your Venture, grow your Streaks,
              receive mentorship, showcase your products, access funding,
              earn trust, strengthen your community and become part of a
              nationwide movement creating meaningful opportunities for young women.
            </p>
          </div>
        </div>

        {/* Vision Beyond Business */}
        <div className="mt-8">
            <div className="text-center mb-4">
                <div className="uppercase tracking-[0.25em] text-pink-300 font-semibold mb-4">
                    🌍 A MOVEMENT WITH PURPOSE
                </div>
                <h2 className="text-xl lg:text-2xl font-black text-white mb-4">
                    Every woman empowered creates opportunities<br /> for generations to come.
                </h2>
                <p className="max-w-4xl mx-auto text-sm lg:text-lg text-rose-200 leading-relaxed">
                    FoundHer is more than an entrepreneurship platform. It is Think5Whys'
                    commitment to helping young women discover purpose, build confidence,
                    embrace digital technologies, understand AI, participate in the data
                    economy, and create sustainable livelihoods for themselves, their
                    families and their communities.
                </p>
            </div>

        <div className="grid lg:grid-cols-2 gap-5">
            {/* India */}
            <div className="rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md p-6">
                <div className="text-xl mb-3">
                    🇮🇳
                </div>
                <h3 className="text-lg font-bold text-white mb-3">
                    Building India's Next Generation of Women Entrepreneurs
                </h3>
                <p className="text-sm text-rose-200 leading-relaxed mb-4">
                    India is home to an estimated <strong>120–135 million women between the ages of 18 and 30.</strong>
                    Among them are students, graduates, homemakers, creators, professionals,
                    artisans and dreamers waiting for the right opportunity.
                </p>
                <p className="text-sm text-rose-200 leading-relaxed">
                    Our vision is to help millions of young women become digitally confident,
                    financially independent and purpose-driven entrepreneurs through
                    Think5Whys, PurpleDoor and community-powered support.
                </p>
            </div>
            {/* Global South */}
            <div className="rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md p-6">
                <div className="text-xl mb-3">
                    🌏
                </div>
                <h3 className="text-lg font-bold text-white mb-3">
                    Expanding Across the Global South
                </h3>
                <p className="text-sm text-rose-200 leading-relaxed mb-4">
                    Across Asia, Africa and Latin America, millions of talented young women
                    face similar challenges—limited access to mentorship, markets,
                    technology, finance and entrepreneurial ecosystems.
                </p>
                <p className="text-sm text-rose-200 leading-relaxed">
                    FoundHer aims to create a scalable phygital ecosystem that communities
                    can adapt locally while sharing knowledge, digital opportunities and
                    entrepreneurial success globally.
                </p>
            </div>
        </div>

        {/* Vision */}
        <div className="mt-6 rounded-3xl border border-pink-400/20 bg-gradient-to-r from-pink-600/10 via-fuchsia-600/10 to-purple-600/10 p-6">
            <h3 className="text-lg lg:text-xl font-bold text-white text-center mb-4">
            💜 Our Long-Term Vision
            </h3>
            <div className="grid md:grid-cols-4 gap-4 text-center">
                <div>
                    <div className="text-2xl font-black text-pink-300">
                    500M+
                    </div>
                    <div className="text-xs text-rose-200 mt-2">
                    Women Inspired
                    </div>
                </div>
                <div>
                    <div className="text-2xl font-black text-pink-300">
                    100K+
                    </div>
                    <div className="text-xs text-rose-200 mt-2">
                    Active Founders
                    </div>
                </div>
                <div>
                    <div className="text-2xl font-black text-pink-300">
                    100K+
                    </div>
                    <div className="text-xs text-rose-200 mt-2">
                    Digital Boutiques
                    </div>
                </div>
                <div>
                    <div className="text-2xl font-black text-pink-300">
                    100+
                    </div>
                    <div className="text-xs text-rose-200 mt-2">
                    Communities Connected
                    </div>
                </div>
            </div>
        </div>

        {/* SDGs */}
        <div className="mt-6 rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md p-6 text-center">
            <div className="text-2xl mb-3">
                🇺🇳
            </div>
            <h3 className="text-lg lg:text-xl font-bold text-white mb-3">
             Supporting the United Nations Sustainable Development Goals
            </h3>

            <p className="text-sm lg:text-base text-rose-200 leading-relaxed max-w-4xl mx-auto">
                FoundHer aligns with the spirit of the UN Sustainable Development Goals,
                particularly <strong>SDG 5 (Gender Equality)</strong>,
                <strong> SDG 8 (Decent Work & Economic Growth)</strong>,
                <strong> SDG 9 (Industry, Innovation & Infrastructure)</strong> and
                <strong> SDG 10 (Reduced Inequalities)</strong>. By empowering young women
                with purpose, digital skills, entrepreneurship and community support,
                we aspire to contribute to inclusive and sustainable economic growth.
            </p>
        </div>
        </div>
      </div>
    </section>
  );
};

export default FoundHerOpportunities;